// packages/common/types/responseStatus.ts
export type ResponseStatus =
  | 'OK'
  | 'Created'
  | 'Unauthorized'
  | 'Accepted'
  | 'NoContent'
  | 'BadRequest'
  | 'NotFound'
  | 'InternalServerError'
  | 'Conflict'
  | 'Gone';

export const ResponseStatusCode: { [key in ResponseStatus]: number } = {
  OK: 200,
  Created: 201,
  Unauthorized: 401,
  Accepted: 202,
  NoContent: 204,
  BadRequest: 400,
  NotFound: 404,
  InternalServerError: 500,
  Conflict: 409,
  Gone: 410,
};

export const ResponseStatusValues = {
  OK: 'OK' as ResponseStatus,
  BadRequest: 'BadRequest' as ResponseStatus,
  NoContent: 'NoContent' as ResponseStatus,
  NotFound: 'NotFound' as ResponseStatus,
  InternalServerError: 'InternalServerError' as ResponseStatus,
  Conflict: 'Conflict' as ResponseStatus,
};

export const ResponseStatusValuesNumbers = {
  OK: ResponseStatusCode.OK,
  BadRequest: ResponseStatusCode.BadRequest,
  NoContent: ResponseStatusCode.NoContent,
  NotFound: ResponseStatusCode.NotFound,
  InternalServerError: ResponseStatusCode.InternalServerError,
  Conflict: ResponseStatusCode.Conflict,
};
